import axios from '../http'

function query(data) {
    return axios.post('/event/schedule/query', data);
}

function get(id) {
    return axios.get('/event/schedule/get?id=' + id);
}

function arrange(data) {
    return axios.post('/event/schedule/arrange', data);
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/event/schedule/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}

function exportExcel(data){
    const url =  "/event/schedule/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(res);
            link.download = "Schedule List.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
}

function printStartOrder(id) {
    const url = "/event/schedule/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


function exportStartOrder(id){
    const url = "/event/schedule/exportStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Daily Start List.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function printResultOrder(id) {
    const url = "/event/schedule/printResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function exportResultOrder(id){
    const url = "/event/schedule/exportResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Results by Daily.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

export default {
    query,
    arrange,
    get,
    importExcel,
    exportExcel,
    printStartOrder,
    exportStartOrder,
    printResultOrder,
    exportResultOrder
}